// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_body__6gbIm {
  border: 1px solid white;
  width: 50%;
  height: fit-content;
  background-color: #fff;
  border-radius: 1rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden; }
  @media (max-width: 768px) {
    .styles_body__6gbIm {
      width: unset; } }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Modal/styles.module.scss","webpack://./src/modules/Core/styles/mixins.scss"],"names":[],"mappings":"AACA;EACI,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB,EAAA;ECHlB;IDPF;MAYQ,YAAa,EAAA,EAEpB","sourcesContent":["@import \"src/modules/Core/styles/mixins.scss\";\n.body {\n    border: 1px solid white;\n    width: 50%;\n    height: fit-content;\n    background-color: #fff;\n    border-radius: 1rem;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    overflow: hidden;\n    @include mobile {\n        width:  unset;\n    }\n}","// @import \"src/modules/Core/styles/mixins.scss\";\n@mixin respond-to($breakpoint) {\n  @media (max-width: $breakpoint) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin multilineText($lines){\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  display: -webkit-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `styles_body__6gbIm`
};
export default ___CSS_LOADER_EXPORT___;
